module.exports = __webpack_public_path__ + "f674058c212af0ed33d156b5fc30f99c.png";